import React, { useEffect, useRef, useState } from "react";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { CloseIcon, RotateIcon } from "../../Assets/assets";
import Button from "../Button/Button";

function CropperModal(props) {
  const [file, setFile] = useState("");
  const cropperRef = useRef(null);
  const [cropperReady, setCropperReady] = useState(false);
  // the file should be in URL.createObjectURL(file)
  useEffect(() => {
    if (props.file) {
      setFile(props.file);
    }
  }, [props.file]);

  async function cropHandler() {
    cropperRef.current?.getCroppedCanvas(props.exportSettings || {})?.toBlob(
      (blob) => {
        props.OnBlobCreate(blob);
      },
      `image/${props.imageFormat || "png"}`,
      1
    );
    resetCropper();
  }

  function handleCloseCropperModal() {
    resetCropper();
  }

  function resetCropper() {
    setFile("");
    props.setFile();
    setCropperReady(false);
  }

  useEffect(() => {
    if (file) {
      const canvas = document.getElementById("imageData");
      const ctx = canvas.getContext("2d");
      const maxW = 1024;
      const maxH = 1024;
      const img = new Image();
      img.onload = function() {
        const iw = img.width;
        const ih = img.height;
        const scale = Math.min(maxW / iw, maxH / ih);
        const iwScaled = iw * scale;
        const ihScaled = ih * scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;
        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
        cropperRef.current = new Cropper(canvas, {
          viewMode: 2,
          background: false,
          zoomable: true,
          dragMode: "move",
          responsive: true,
          guides: false,
          rotatable: true,
          ...(props.aspectRatio ? { aspectRatio: props.aspectRatio } : {})
        });
        setCropperReady(true);
      };
      img.src = file;
    }
  }, [file, props.aspectRatio]);

  return (
    file && (
      <div
        data-cy="cropper-modal"
        className={`${props.className ||
          ""} background-color-black inherit-parent-height inherit-parent-width flex-center-children-horizontally flex-direction-column`}
      >
        <div className="font-color-tertiaryColor display-flex inherit-parent-width flex-justify-content-space-between padding-large">
          <div>CROP IMAGE</div>
          <div onClick={handleCloseCropperModal}>
            <CloseIcon />
          </div>
        </div>
        <div className="inherit-parent-height inherit-parent-width">
          <canvas
            style={{
              width: "100%",
              maxHeight: "600px",
              height: "auto",
              display: "block"
            }}
            id="imageData"
            data-cy="cropper-canvas"
          />
        </div>
        <footer className="padding-larger inherit-parent-width flex-align-items-center flex-justify-content-space-between">
          <Button
            text="Rotate"
            boxShadow={false}
            variant="transparent"
            data-cy="cropper-rotate-button"
            icon={
              <RotateIcon
                height="12"
                width="12"
                color="var(--tertiaryColor6)"
              />
            }
            onClick={() => {
              if (cropperReady && cropperRef.current) {
                cropperRef.current.rotate(90);
              }
            }}
            className="width-fit-content padding-left-large padding-right-large"
          />
          <div className="display-flex">
            <Button
              text="Save"
              boxShadow={false}
              data-cy="CROP-IMG-CONFIRM-BUTTON"
              className="padding-left-large padding-right-large font-color-tertiaryColor"
              disabled={!cropperReady}
              onClick={cropHandler}
            />
            <Button
              text="Cancel"
              variant="transparent"
              boxShadow={false}
              data-cy="crop-img-cancel-button"
              className="padding-left-large padding-right-large font-color-tertiaryColor"
              onClick={handleCloseCropperModal}
            />
          </div>
        </footer>
      </div>
    )
  );
}

export default CropperModal;
